import React from "react";
import { Helmet } from "react-helmet-async";
import { useAppSelector } from "hooks/redux";
import { buildAdminTabTitle } from "helpers/buildAdminTabTitle";

export default function FacilityTabTitle(): JSX.Element {
  const facility = useAppSelector(s => s.facilityStore.facility);
  const segment = facility?.long_name ?? facility?.full_name ?? facility?.short_name;
  return (
    <Helmet>
      <title>{buildAdminTabTitle(segment)}</title>
    </Helmet>
  );
}
